// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const cpr: CountryValidator<"DK", ParsedPersonId> =
  createValidator("dk.cpr", 56);

export default cpr;
export const compact = cpr.compact;
export const format = cpr.format;
export const validate = cpr.validate;
export const generate = (): string =>
  cpr.generate?.() ??
  (() => {
    throw new Error(
      "Validator dk.cpr cannot generate values",
    );
  })();
export const parse = cpr.parse;
